<template>
    <section :id="sectionId" class="mb-10">
        <h2 class="text-xl font-semibold mb-2">Netrefer</h2>
        <Accordion :multiple="true" v-model:activeIndex="accordionActive">
            <AccordionTab header="Setting up tracking links">
                <p class="text-sm text-gray-400">
                    Documentation for setting up Netrefer tracking links is coming soon.
                </p>
            </AccordionTab>
        </Accordion>
    </section>
</template>

<script setup>
import Accordion from 'primevue/accordion';
import AccordionTab from 'primevue/accordiontab';
import { useHelpSection } from './useHelpSection';
const { sectionId, accordionActive } = useHelpSection('links-netrefer');
</script>
